// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"7001":"3b1b39b44a253483","9382":"3b1b39b44a253483"}[chunkId] + ".css";
};